<div class="twc-d-flex flex-direction-column align-center">
    <h4 class="twc-h4" *ngIf="!showDetail; else showDetailHeader"> {{title}} </h4>
    <twc-switch #dataSwitch>
        <twc-switch-link *ngFor="let data of reportData" [data]="data">
            {{ data.label | translate }}
        </twc-switch-link>
    </twc-switch>

    <div class="twc-d-flex align-center" *ngIf="dataSwitch.selectedItem">
        <twc-progress-loader [progress]="getLoaderPercentage(dataSwitch.selectedItem.data)"></twc-progress-loader>

        <div class="text-data-container">
            <div class="font-bold">
                <span *ngIf="dataSwitch.selectedItem.data.unit; else withoutUnit">
                    {{toFixedWithPrecision(dataSwitch.selectedItem.data.value) }} {{dataSwitch.selectedItem.data.unit |
                    translate}} /
                    {{dataSwitch.selectedItem.data.maxValue }} {{dataSwitch.selectedItem.data.unit | translate}}
                </span>

                <ng-template #withoutUnit>
                    <span>
                        {{toFixedWithPrecision(dataSwitch.selectedItem.data.value) | bytes }} /
                        {{dataSwitch.selectedItem.data.maxValue |
                        bytes}}
                    </span>
                </ng-template>
            </div>
            <div>
                {{ getValidPercentage(dataSwitch.selectedItem.data) }}
            </div>
        </div>
    </div>
</div>
<ng-template #showDetailHeader>
    <div class="show-detail-header">
        <twc-icon [shape]="getDetailIcon()"></twc-icon>
        <h4 class="twc-h4"> {{title}} </h4>
        <button class="twc-button twc-button-link twc-button-icon" (click)="openDetail(dataSwitch.selectedItem?.data)">
            <twc-icon shape="info"></twc-icon>
        </button>
    </div>
</ng-template>